import {
	comMapping
} from '../../../util/Function/comMapping.js'

export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrmc",
				label: '纳税人名称',
				type: "input"
			},
			{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "shuizId",
				label: '税表名称',
				type: "select",
				selectval: []
			},
			{
				prop: "bbzt",
				label: '报表状态',
				type: "select",
				selectval: [],
			},
		],
		bbztsb: [{
				label: "草稿",
				value: "0"
			},
			{
				label: "未填写",
				value: "-1"
			},
			{
				label: "底稿",
				value: "1",
				color: "#6DC0FF"
			},
			{
				label: "提交中",
				value: "2",
				color: "#F7B500"
			},
			{
				label: "审核成功",
				value: "3",
				color: "#0065B1"
			},
			{
				label: "审核失败",
				value: "4",
				color: "#E02020"
			},
			{
				label: "申报中",
				value: "5",
				color: "#F7B500"
			},
			{
				label: "申报成功",
				value: "6",
				color: "#0065B1"
			},
			{
				label: "申报失败",
				value: "7",
				color: "#E02020"
			},
			// {
			// 	label: "申报作废",
			// 	value: "8"
			// },
			{
				label: "缴款成功",
				value: "9",
			},
			{
				label: "缴款失败",
				value: "10",
				color: "#E02020"
			},
			{
				label: "缴款中",
				value: "11",
				color: "#F7B500"
			},
			{
				label: "申报作废中",
				value: "12",
				color: "#F7B500"
			},
			// {
			// 	label: "草稿",
			// 	value: "13"
			// },
			{
				label: "作废成功",
				value: "14",
				color: "#0065B1"
			},
			{
				label: "取消审核",
				value: "15",
				color: "#F7B500"
			},
			// {
			// 	label: "发起PDF下载",
			// 	value: "16"
			// },
			{
				label: "作废失败",
				value: "17",
				color: "#E02020"
			},
			// {
			// 	label: "PDF下载失败",
			// 	value: "18"
			// }
			{
				label: "申报更正",
				value: "24",
				color: "#F7B500"
			},

		],
		searchdata: {
			nsrmc: "",
			companyCode: "",
			shuizId: "",
			bbzt: "",
			jzslsbqy: false
		},
		headData: [

			{
				title: "纳税人名称",
				prop: "nsrmc",
				width: 85,
				custom: true,

			},
			{
				title: "公司代码",
				prop: "companyCode",
				custom: true,
				width: 75,
			},
			{
				title: "税表名称",
				prop: "sbzl",
				custom: true,
				headcustom: true,
				width: 130,
				headprop: 'sbzlhead'
			},
			{
				title: "应补（退）税额（附加税额）",
				prop: "ybtse",
				width: "170",
				AmountFormat: true,
				custom: true,
			},
			// {
			// 	title: "附加税额",
			// 	prop: "fujse",
			// 	width: "130" ,
			// 	AmountFormat:true,
			// 	align:"right"
			// },
			{
				title: "报表状态",
				prop: "status",
				width: 90,
				custom: true,
			},
			{
				title: "风险",
				prop: "fxs",
				custom: true,
				width: 50,
			},
			{
				title: "附件",
				prop: "fjs",
				custom: true,
				width: 50,
			},
			{
				title: "是否报送",
				prop: "sfbs",
				custom: true,
				width: 75
			},
			{
				title: "税款所属期起",
				prop: "shenbqFrom",
				custom: true,
				width: 100
			},
			{
				title: "税款所属期止",
				custom: true,
				prop: "shenbqTo",
				width: 100
			},
			{
				title: "申报截至日期",
				custom: true,
				prop: "shenbEndDate",
				width: 100
			},
			{
				title: "本期非零申报说明",
				prop: "nonZeroDeclarationInstructions",
				width: 100
			},
			{
				title: "操作",
				prop: "cz",
				fixed: "right",
				custom: true,
				width: 130
			},
		],
		tableData: [],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		pagination_risk: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		formlist: [{
			prop: "type",
			label: "类型",
			type: "select",
			width: "220px",
			selectval: [{
					label: "报表 ",
					value: "1"
				},
				{
					label: "完税凭证",
					value: "2"
				},
				{
					label: "涉税资料",
					value: "3"
				},
				{
					label: "强制弹框附注",
					value: "4"
				}
			]

		}, {
			prop: "name",
			label: "名称",
			type: "input",
			width: "280px"

		}, {
			prop: "description",
			label: "描述",
			type: "textarea",
			width: "220px"

		}],
		paginationfile: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headseeData: [{
				title: "类型",
				prop: "type",
				custom: true
			},
			{
				title: "名称",
				prop: "name",
			},
			{
				title: "描述",
				prop: "description",
				width: "200"
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				width: "120"
			},
		],
		tableseeData: [{}, {}],
		//印花税次报
		headDatasecondary: [{
				title: "纳税人名称",
				prop: "nsrmc",
			},
			{
				title: "公司代码",
				prop: "companyCode",
			}
		],
		headDatafx: [{
				title: "指标大类",
				prop: "category",
				custom: true
			},
			{
				title: "指标类型",
				prop: "type",
				custom: true
			},
			{
				title: "指标名称",
				prop: "name",
				width: "200px"
			},
			{
				title: "预警值",
				prop: "valveValue",
				custom: true

			},
			{
				title: "指标值",
				prop: "nowValue",
				custom: true

			},
			{
				title: "最新更新时间",
				prop: "updateTime",
				width: "200px"
			},
		]
	}
	return obj
}